import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './state'
import { reducers } from './reducers'

export const summarySlice = createSlice({
  name: 'users',
  initialState,
  reducers
})

// Get Balance
export const { setBalanceLoading } = summarySlice.actions
export const { setBalanceResponse } = summarySlice.actions
export const { setBalanceError } = summarySlice.actions

// Filter by days to display data in chart and table
export const { setFilter } = summarySlice.actions
// Get Sales Data
export const { setSalesDataLoading } = summarySlice.actions
export const { setSalesDataResponse } = summarySlice.actions
export const { setSalesDataError } = summarySlice.actions
export const { setSalesDataPlot } = summarySlice.actions

// Get Orders Data
export const { setOrdersDataLoading } = summarySlice.actions
export const { setOrdersDataResponse } = summarySlice.actions
export const { setOrdersDataError } = summarySlice.actions
export const { setOrdersDataPlot } = summarySlice.actions

// Create Deposit
export const { setDepositLoading } = summarySlice.actions
export const { setDepositResponse } = summarySlice.actions
export const { setDepositError } = summarySlice.actions
export const { setDepositSuccess } = summarySlice.actions
export const { setDepositPayPalUrl } = summarySlice.actions
export const { setDepositCreditCardInfo } = summarySlice.actions
export const { setDepositSubmit } = summarySlice.actions
export const { resetDepositSuccessState } = summarySlice.actions
export const { resetDepositPayPalUrlState } = summarySlice.actions
export const { resetDepositSubmitState } = summarySlice.actions

// Create Withdraw with PayPal
export const { setWithdrawPayPalLoading } = summarySlice.actions
export const { setWithdrawPayPalSuccess } = summarySlice.actions
export const { setWithdrawPayPalError } = summarySlice.actions
export const { resetWithdrawPayPalState } = summarySlice.actions

export default summarySlice.reducer
